import { httpClient } from '@/services/http/httpClient'

type ChangeChallengeParams = {
  ideaId: string
  challengeId: string
}

export async function changeChallenge({
  challengeId,
  ideaId,
}: ChangeChallengeParams) {
  await httpClient.put(`/ideas/ideas/${ideaId}/campaign`, {
    campaignId: challengeId,
  })
}
